export default __webpack_public_path__ + "static/media/customer.a250e120.png";